import { createFileRoute, redirect } from "@tanstack/react-router";

// Old English address of the legal notice: permanent redirect to /impressum.
export const Route = createFileRoute("/imprint")({
  loader: () => {
    throw redirect({ to: "/impressum", statusCode: 301 });
  },
});
